import React, { Component, Fragment } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import { hot } from 'react-hot-loader';
import axios from "axios";
import {message} from "antd";
import { Provider } from 'react-redux';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.css';
import Router from './Router';
import Register from "../Register/Register";
import Logout from "../Logout";
import store from './store';
import ScrollToTop from './ScrollToTop';
import LoginCallback from '../LoginCallback';
import 'antd/dist/antd.css';
import '../../scss/app.scss';
import './App.scss'
import '../Home/Home.scss';


class App extends Component {
    constructor() {
        super();
        this.state = {
            configData: {}
        }
    }

    async componentWillMount() {
        await this.fetchConfig()
    }

    fetchConfig = async () => {
        const data = await axios.get(`${process.env.PUBLIC_URL}/config.json` )
        if (!data || data.error) {
            return message.error('something is wrong! please try again');
        } else {
            localStorage.setItem("API_ENDPOINT", data.data.API_ENDPOINT || "")
            localStorage.setItem("CERTIFICATION_API_ENDPOINT", data.data.CERTIFICATION_ENDPOINT || "")
            localStorage.setItem("IS_USER_CERTIFICATION", data.data.UseCertificationAPI || false)
            localStorage.setItem("IS_SIGN_OFF_DATA_REQUIRED", data.data.isSignOffDataRequired || false)
            localStorage.setItem("STATUS_LIST", JSON.stringify(data.data.statusList || {}))
            localStorage.setItem("PROVIDE_INFO_MESSAGE", data.data.ProvideInfoMessage || "")
            localStorage.setItem("RECORD_LENGTH", data.data.TotalViewingRecord || 3)
            localStorage.setItem("DATE_FORMAT", data.data.DateFormat || "")
            localStorage.setItem("SESSION_TIMEOUT", data.data.SessionTimeOut || "")
            localStorage.setItem("ERROR_MESSAGE", data.data.ErrorMessage || "")
            localStorage.setItem("SSOEnabled", data.data.SSOEnabled || "")
            localStorage.setItem("isSSO", data.data.isSSO)
            localStorage.setItem("logoutURL", data.data.logoutURL)
            // this.props.setLocalData(data.data)
            this.setState({
                configData: data.data
            })
        }
    }

    render() {
        if(!Object.keys(this.state.configData).length) return null;
        return (
            <Provider store={store}>
                <BrowserRouter basename={"/iga"}>
                    <ScrollToTop>
                        <Fragment>
                            <div>
                                <Switch>
                                    <Route path="/register" component={Register} />
                                    <Route path="/sso/callback" component={LoginCallback} />
                                    <Route path="/logout" component={Logout} />
                                    <Route path="/:clientId" render={(props) => <Router {...props} configProps={this.state.configData || {}} />}/>
                                </Switch>
                            </div>
                        </Fragment>
                    </ScrollToTop>
                </BrowserRouter>
            </Provider>
        );
    }
}

export default hot(module)(App);
